export type InterviewAdmissionFailure = 'no_credits' | 'busy' | 'check_unavailable'

export interface InterviewAdmissionResult {
  canJoin: boolean
  isInterview?: boolean
  reason?: string
  interviewId?: string
}

export const INTERVIEW_LIMIT_MESSAGE = 'Все комнаты сейчас заняты. Попробуйте подключиться позже.'
export const INTERVIEW_CHECK_UNAVAILABLE_MESSAGE = 'Не удалось проверить доступность комнаты. Попробуйте подключиться позже.'

const interviewRoomTypes = new Set([
  'textAssistant', 'voiceAssistant', 'voiceAssistant2',
  'text_assistant', 'voice_assistant', 'voice_assistant_2',
])

export interface InterviewAdmissionContext {
  [key: string]: unknown
  roomType?: unknown
  v?: unknown
  project?: unknown
  interview?: unknown
}

/** Лимиты HR применяются к текстовым и голосовым комнатам. */
export function shouldCheckInterviewLimit(context: InterviewAdmissionContext): boolean {
  if (context.roomType != null && context.roomType !== 'null') {
    return typeof context.roomType === 'string' && interviewRoomTypes.has(context.roomType)
  }
  return (typeof context.v === 'string' && ['hr', 'fa', 'ma'].includes(context.v)) ||
    context.interview === true || context.interview === 'true' || context.interview === ''
}

/** The interview limit is mandatory even when the legacy busy guard is disabled. */
export function getInterviewAdmissionFailure(
  result: Partial<InterviewAdmissionResult>,
  busyGuardEnabled = true,
): InterviewAdmissionFailure | null {
  if (result?.canJoin !== false) return null
  if (result.reason === 'no_credits' || result.reason === 'check_unavailable') return result.reason
  return busyGuardEnabled && result.reason === 'busy' ? 'busy' : null
}
